import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import { Tag, Tooltip } from "antd";
import moment from 'moment';

import { FilterFilled } from "@ant-design/icons";

import { getData } from '../../config/api-connect';

import { getColumnFilters, getColumnSearchProps } from '../../utils/filters';
import SummaryLayout from "../../components/layout/SummaryLayout";

function RazorpayList() {
  const location = useLocation();

  const [month, setMonth] = useState();
  const [year, setYear] = useState();

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [filteredCount, setFilteredCount] = useState(data ? data.length : 0);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
  });

  const formatted = moment(`${year}-${month}`, "YYYY-MM").format("MMMM YYYY");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    setMonth(params.get("month"));
    setYear(params.get("year"));
  }, [location.search]);

  useEffect(() => {
    if (month && year) {
      getRazorpayEntries();
    }
  }, [month, year]);

  const getRazorpayEntries = () => {
    setLoader(true);
    getData(`/finance/get_razorpay_entries/?&month=${month}&year=${year}`)
      .then(response => {
        setData(response.result)
        setFilteredCount(response.result.length)
        setLoader(false)
      })
      .catch(error => {
        setLoader(false)
        alert(error.message);
      });
  }

  const handleTableChange = (pager, filters, sorter, extra) => {
    setPagination({
      ...pagination,
      current: pager.current,
      pageSize: pager.pageSize,
    });

    setFilteredCount(extra.currentDataSource.length);
  };

  const uniqueValues = (key) => Array.from(new Set(data.map(r => r[key]).filter(Boolean))).sort();

  const columns = [
    {
      title: "Paid Date",
      dataIndex: "created_at",
    },
    {
      title: "Payment ID",
      dataIndex: "payment_id",
      ...getColumnSearchProps('payment_id'),
    },
    {
      title: "Order ID",
      dataIndex: "order_id",
      ...getColumnSearchProps('order_id')
    },
    {
      title: "Contact",
      dataIndex: "contact",
      ...getColumnSearchProps('contact'),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      ...getColumnSearchProps('status'),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Collection Tagged",
      dataIndex: "collection_id",
      align: "center",

      render: (collection_id, record) => {
        const isTagged = !!collection_id;

        if (!isTagged) {
          return (
            <Tag color="red">
              Not Tagged
            </Tag>
          );
        }

        const tooltipContent = (
          <div>
            <div><b>Collection ID:</b> {collection_id}</div>
            <div><b>Name:</b> {record.customer_name || "-"}</div>
            <div><b>Mobile:</b> {record.mobile_no || "-"}</div>
            <div><b>Admin Comment:</b> {record.admin_comment || "-"}</div>
          </div>
        );

        return (
          <Tooltip title={tooltipContent}>
            <Tag color="green" style={{cursor: 'pointer'}}>Tagged</Tag>
          </Tooltip>
        );
      },

      filters: [
        { text: 'Tagged', value: true },
        { text: 'Not Tagged', value: false },
      ],

      onFilter: (value, record) =>
        Boolean(record.collection_id) === value,

      filterIcon: () => (
        <FilterFilled style={{ color: "white" }} />
      ),
    },
    {
      title: "Verified",
      dataIndex: "is_verified",
      align: "center",
      render: (text) => {
        let color = "orange";

        if (text === true) {
          color = "green";
        } else if (text === false) {
          color = "red";
        }

        return <Tag color={color}>{text ? "Verified" : "Not Verified"}</Tag>;
      },
      filters: [
        { text: 'Verified', value: true },
        { text: 'Not Verified', value: false },
      ],
      onFilter: (value, record) => Boolean(record.is_verified) === Boolean(value),
      filterIcon: () => (<FilterFilled style={{ color: "white" }} />),
    },
    // {
    //   title: "Status",
    //   dataIndex: "Verification_Label",
    //   align: "center",
    //   ...getColumnFilters('Verification_Label', uniqueValues('Verification_Label')),
    //   render: (text) => {
    //     let color = "orange";

    //     if (text === "Verified") {
    //       color = "green";
    //     } else if (text === "No Matches Found") {
    //       color = "red";
    //     }

    //     return <Tag color={color}>{text}</Tag>;
    //   }
    // }
  ];

  return (
    <SummaryLayout
      title="Razorpay Entries"
      headerContent={
        <Tag color="blue" style={{ fontSize: "14px", padding: "2px 8px" }}>
          {formatted}
        </Tag>
      }
      hasBackButton={true}
      tableProps={{
        columns,
        data: data,
        loading: loader,
        onChange: handleTableChange,
        pagination: {
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }
      }}
      extraContent={
        <div style={{ textAlign: 'center' }}>
          Showing {filteredCount} records
        </div>
      }
    />
  )
}

export default RazorpayList;
